import { toast } from "react-toastify";

const errorMessage = async (err, message) => {
    if(!(err?.response?.status !== 422)){
        toast.error(
            <>
                <h3>Ошибки валидации:</h3>
                {err?.response?.data?.errors && Object.values(err?.response?.data?.errors).map(e =>
                    <p>- {e}</p>
                )}
            </>, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
    } else if(message === 'Test') {
        toast.error(
            <>
                <h3>Test:</h3>
                {err?.response?.data?.errors && Object.values(err?.response?.data?.errors).map(e =>
                    <p>- {e}</p>
                )}
            </>, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
    } else {
        toast.error(
            <>
                <h3>{message}</h3>
                {err?.response?.data?.errors && Object.values(err?.response?.data?.errors).map(e =>
                    <p>- {e}</p>
                )}
            </>, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
    }
}

export default errorMessage;